import React from "react";
import './loadingView.css';
import logo from '../assets/logo.png'
import { translateUiText } from '../i18n';


function LoadingView({ locale = 'en' }){

    return(
        <div className='main-content'>
          
            <img className="logo-loading" src={logo} alt={translateUiText(locale, 'foodAllergyCardAlt')} />
              <p>{translateUiText(locale, 'loading')}</p>
        </div>

    )
}

export default LoadingView
